// Spiegel von OutageMath (Server): „Alarm nach N" löst erst aus, wenn N Meldungen samt Kulanz
// ausgeblieben sind. Kulanz je Meldung: Agent 15 s (HTTP-Timeout verschiebt den Takt),
// Cloud 40 s (Poll-Takt 30 s + Check-Timeout 10 s).
export const AGENT_SLACK_SECONDS = 15
export const CLOUD_SLACK_SECONDS = 40

const ALLOWED_ALERT_AFTER = [2, 3, 4, 5, 6]
const SHORT_SILENCE_SECONDS = 120

export function alertThresholdSeconds(intervalSeconds: number, alertAfterMissed: number, isCloud: boolean): number {
  const slack = isCloud ? CLOUD_SLACK_SECONDS : AGENT_SLACK_SECONDS
  return Math.max(1, alertAfterMissed) * (Math.max(1, intervalSeconds) + slack)
}

// Feste Regel (Entscheidung 01.11.2026): N × Intervall unter 2 Minuten ⇒ Hinweis, dass kurze
// Netz-Aussetzer Fehlalarme auslösen können. recommendedMin = kleinstes erlaubtes N ab 2 Minuten,
// null wenn auch der Höchstwert darunter bleibt (dann hilft nur ein längeres Intervall).
export function smallAlertAfterHint(
  intervalSeconds: number,
  alertAfterMissed: number,
): { recommendedMin: number | null } | null {
  if (alertAfterMissed * intervalSeconds >= SHORT_SILENCE_SECONDS) return null
  const min = ALLOWED_ALERT_AFTER.find((n) => n * intervalSeconds >= SHORT_SILENCE_SECONDS)
  return { recommendedMin: min ?? null }
}

export function formatDuration(seconds: number): string {
  const h = Math.floor(seconds / 3600)
  const m = Math.floor((seconds % 3600) / 60)
  const s = seconds % 60
  const parts = [h && `${h} Std`, m && `${m} Min`, s && `${s} Sek`].filter(Boolean)
  return parts.length > 0 ? parts.join(' ') : '0 Sek'
}
